import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { PlayerController } from '@splixer/player';
import { faCirclePlay } from '@fortawesome/pro-duotone-svg-icons/faCirclePlay';
import { faCirclePause } from '@fortawesome/pro-duotone-svg-icons/faCirclePause';
import { faAnglesLeft } from '@fortawesome/pro-regular-svg-icons/faAnglesLeft';
import { faAnglesRight } from '@fortawesome/pro-regular-svg-icons/faAnglesRight';
import { faForwardStep } from '@fortawesome/pro-solid-svg-icons/faForwardStep';
import { faBackwardStep } from '@fortawesome/pro-solid-svg-icons/faBackwardStep';
import { NgStyle } from '@angular/common';
import {
  FaDuotoneIconComponent,
  FaIconComponent,
} from '@fortawesome/angular-fontawesome';
import { SecondsToMinutesPipe } from '@hidat/ng-common';

@Component({
  selector: 'pv2-player',
  templateUrl: 'v2-player.component.html',
  styleUrl: 'v2-player.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgStyle,
    FaIconComponent,
    FaDuotoneIconComponent,
    SecondsToMinutesPipe,
  ],
})
export class PV2PlayerComponent extends PlayerController {
  public canScrub = input(true, { transform: booleanAttribute });
  public canScrubBack = input(true, { transform: booleanAttribute });
  public canSkip = input(true, { transform: booleanAttribute });

  protected playIcon = faCirclePlay;
  protected pauseIcon = faCirclePause;
  protected backIcon = faAnglesLeft;
  protected forwardIcon = faAnglesRight;
  protected skipForwardIcon = faForwardStep;
  protected skipBackIcon = faBackwardStep;

  public startOver = () => {
    this.playerEngine.setPosition(0);
  };

  public skip = () => {
    /*if (this.session.canSkip()) {*/
    this.playbackService.skipSegment();
  };
}
